import SectionHead from "../components/SectionHead";
import { Reveal } from "../components/motion";
import { useLang } from "../i18n";

const TITULAR = "Irene Infante Riol";
const DIRECCION = "Carrer Romaní 19, 08348 Cabrils (Barcelona)";

const TYPE_MAP = { legal: "aviso", privacidad: "privacidad", cookies: "cookies" };

const LegalPage = ({ type }) => {
    const { t } = useLang();
    const content = t.legal[TYPE_MAP[type]] || t.legal.aviso;

    return (
        <main data-testid={`legal-page-${type}`} className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-24">
            <SectionHead eyebrow="Legal" title={content.title} testid={`legal-title-${type}`} />
            <div className="mt-10 space-y-8">
                {content.sections.map((s, i) => (
                    <Reveal key={s.h} delay={i * 0.04}>
                        <section>
                            <h2 className="font-serif text-xl font-semibold text-terracotta">{s.h}</h2>
                            <p className="mt-2.5 text-[15px] leading-relaxed text-[#525B53]">{s.p}</p>
                        </section>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.1}>
                <p className="mt-12 border-t border-[#E3DCCF] pt-6 text-xs text-[#7C877E]">
                    {t.legal.updated} · {TITULAR} · {DIRECCION}
                </p>
            </Reveal>
        </main>
    );
};

export default LegalPage;
